import { render, staticRenderFns } from "./client-profile.vue?vue&type=template&id=a00b02ea"
import script from "./client-profile.vue?vue&type=script&lang=js"
export * from "./client-profile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports